export const getCommissionForPurchaseAmount = (allNetworkProviders, selectedNetworkProvider, amount) => {
    const networkProviderData = allNetworkProviders.find(
        (airtimeProviderService) => airtimeProviderService.serviceName === selectedNetworkProvider,
    );
    if (!networkProviderData) {
        return 0;
    }
    return (networkProviderData.userCommissionEarning / 100) * amount;
};
